import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import CheckOkButton from './CheckOkButton';
import ConfirmDialog from '../molecules/ConfirmDialog';
import CheckNoneButton from './CheckNoneButton';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openLinkedDialog', 'updateOpenLinkedDialog', false),
  withState('openUnlinkedDialog', 'updateOpenUnlinkedDialog', false)
);

const button = enhance(
  ({
    openLinkedDialog,
    updateOpenLinkedDialog,
    openUnlinkedDialog,
    updateOpenUnlinkedDialog,
    linkPaypayAction,
    unlinkPaypayAction,
    linked,
    shopId
  }) => {
    return (
      <div>
        {linked ? (
          <CheckOkButton
            onClickAction={() => {
              updateOpenUnlinkedDialog(true);
            }}
          />
        ) : (
          <CheckNoneButton
            onClickAction={() => {
              updateOpenLinkedDialog(true);
            }}
          />
        )}

        <ConfirmDialog
          openConfirm={openLinkedDialog}
          updateOpenConfirm={updateOpenLinkedDialog}
          okAction={() => {
            linkPaypayAction(shopId);
            updateOpenLinkedDialog(false);
          }}
          message="Paypay決済導入にしましょうか？"
        />

        <ConfirmDialog
          openConfirm={openUnlinkedDialog}
          updateOpenConfirm={updateOpenUnlinkedDialog}
          okAction={() => {
            unlinkPaypayAction(shopId);
            updateOpenUnlinkedDialog(false);
          }}
          message="Paypay決済導入を解除しましょうか？"
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
